<template>
	<el-collapse v-model="collapse" class="optionBoxs">
		<el-collapse-item title="题型选项" name="1">
			<el-popover
				v-for="(item, index) in options.filter((e) => e.have)"
				:key="index"
				placement="right-start"
				:title="item.title"
				width="320"
				trigger="hover"
				popper-class="questionTypePopper"
				:close-delay="0"
			>
				<a slot="reference" class="questionTypes" @click="handleDefaultClick(item)">
					<svg class="iconpark-icon"><use :href="`#${item.icon}`"></use></svg>
					{{ item.title }}
				</a>

				<template v-if="item.type == 1">
					<el-radio v-model="radio" label="1">选项一</el-radio>
					<el-radio v-model="radio" label="2">选项二</el-radio>
				</template>
				<template v-else-if="item.type == 2">
					<el-radio v-model="radio" label="1">选项一</el-radio>
					<el-radio v-model="radio" label="2">选项二</el-radio>
				</template>
				<template v-else-if="item.type == 3">
					<el-checkbox v-model="checkbox1">选项一</el-checkbox>
					<el-checkbox v-model="checkbox2">选项二</el-checkbox>
				</template>
				<template v-else-if="item.type == 4">
					<div class="simulationUpload">
						<svg class="iconpark-icon"><use href="#tianjiatupian"></use></svg>
						<span>上传图片</span>
					</div>
				</template>
				<template v-else-if="item.type == 11">
					<el-select v-model="select" placeholder="请选择">
						<el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</template>
				<template v-else>
					<el-input v-model="input"></el-input>
				</template>
			</el-popover>
		</el-collapse-item>
		<el-collapse-item v-if="[0, 2].includes(type)" title="常规选项" name="2">
			<el-popover
				v-for="(item, index) in routineOptions"
				:key="index"
				placement="right-start"
				:title="item.title"
				width="320"
				trigger="hover"
				popper-class="questionTypePopper"
				:close-delay="0"
			>
				<a
					slot="reference"
					class="questionTypes"
					:class="{ active: item.active }"
					@click="handleRoutineClick(item)"
				>
					<svg class="iconpark-icon"><use :href="`#${item.icon}`"></use></svg>
					{{ item.title }}
				</a>
				<el-input v-model="input"></el-input>
			</el-popover>
		</el-collapse-item>
	</el-collapse>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';

export default {
	props: {
		type: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			collapse: ['1'],
			// 示例
			input: '',
			radio: '',
			checkbox1: false,
			checkbox2: false,
			select: '',
			options: [
				{
					title: '文本框',
					have: [0, 2].includes(this.type),
					icon: 'wenben',
					type: 0,
				},
                {
					title: '数字框',
					have: [0, 2].includes(this.type),
					icon: 'wenben',
					type: 13,
				},
				{
					title: '单选框',
					have: true,
					icon: 'danxuan',
					type: 1,
				},
				{
					title: '多选框',
					have: true,
					icon: 'duoxuan',
					type: 2,
				},
				{
					title: '下拉选择',
					have: true,
					icon: 'xiala',
					type: 11,
				},
				{
					title: '上传图片',
					have: [0, 2].includes(this.type),
					icon: 'shangchuantupian',
					type: 4,
				},
			],
			routineOptions: [
				{
					title: '姓名',
					have: true,
					icon: 'xingming',
					customType: 'name',
					type: 0,
					active: false,
				},
				{
					title: '性别',
					have: true,
					icon: 'xingbie',
					customType: 'sex',
					type: 0,
					active: false,
				},
				{
					title: '年龄',
					have: true,
					icon: 'nianling',
					customType: 'age',
					type: 0,
					active: false,
				},
				{
					title: '地区',
					have: true,
					icon: 'diqu',
					customType: 'area',
					type: 12,
					active: false,
				},
				{
					title: '手机',
					have: true,
					icon: 'shouji',
					customType: 'phone',
					type: 5,
					active: false,
				},
				{
					title: '邮箱',
					have: true,
					icon: 'youxiang',
					customType: 'email',
					type: 7,
					active: false,
				},
				{
					title: '公司/单位',
					have: true,
					icon: 'gongsi',
					customType: 'company',
					type: 0,
					active: false,
				},
				{
					title: '职位',
					have: true,
					icon: 'zhiwei',
					customType: 'position',
					type: 0,
					active: false,
				},
				{
					title: '用户协议',
					have: true,
					icon: 'xieyi',
					customType: 'protocal',
					type: 8,
					active: false,
				},
				{
					title: '邀请码',
					have: true,
					icon: 'yaoqingma',
					customType: 'inviteCode',
					type: 9,
					active: false,
				},
				{
					title: '修改昵称',
					have: true,
					icon: 'xiugainicheng',
					customType: 'updatenick',
					type: 10,
					active: false,
				},
			],
		};
	},
    computed: {
        ...mapState({
			userInfo: (state) => state.user.userInfo,
		}),
    },
    mounted() {
        if (config.env == 'beta' || ['18811077729', '15101165792'].includes(this.userInfo.mobPhone)) {
            this.options.push({
                title: '定制数字',
                have: [0, 2].includes(this.type),
                icon: 'wenben',
                type: 99,
            });
        }
		if (config.env == 'beta' || ['13918062129'].includes(this.userInfo.mobPhone)) {
            this.options.push({
                title: '医院',
                have: [0, 2].includes(this.type),
                icon: 'xiala',
                type: 98,
            });
        }
    },
	methods: {
		initRoutine(questions) {
			questions.forEach((e) => {
				// 根据disabled 和 title 定位常规选项(用户协议disabled为false)
				if (e.disabled) {
					let taget = this.routineOptions.find((item) => item.title == e.title);
					if (taget) {
						taget.active = true;
					}
				}
				if ([5, 7, 8, 9, 10].includes(e.type)) {
					this.routineOptions.find((item) => item.type == e.type).active = true;
				}
			});
		},
		handleDefaultClick(item) {
			this.$emit('add', item.type);
		},
		handleRoutineClick(item) {
			item.active = !item.active;
			if (item.active) {
				this.$emit('add', item.customType);
			} else {
				this.$emit('remove', item);
			}
		},
		remove(info) {
			if (info.disabled) {
				let taget = this.routineOptions.find((item) => item.title == info.title);
				if (taget) {
					taget.active = false;
				}
			}
			if ([5, 7, 8, 9, 10].includes(info.type)) {
				this.routineOptions.find((item) => item.type == info.type).active = false;
			}
		},
	},
};
</script>

<style lang="less">
.optionBoxs {
	border: none;
	.el-collapse-item {
		border-bottom: 1px solid rgba(229, 230, 235, 1);
		margin-bottom: 4px;
		&:nth-last-of-type(1) {
			border: none;
		}
	}
	.el-collapse-item__header {
		font-size: 14px;
		height: 54px;
		font-weight: normal;
		color: rgba(29, 33, 41, 1);
		border: none;
	}
	.el-collapse-item__wrap {
		border: none;
	}
	.el-collapse-item__content {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: 1fr 1fr;
		gap: 8px 16px;
		padding-bottom: 20px;
		.questionTypes {
			height: 28px;
			cursor: pointer;
			border: 1px solid rgba(229, 230, 235, 1);
			border-radius: 2px;
			display: flex;
			padding-left: 8px;
			align-items: center;
			font-size: 14px;
			color: rgba(134, 144, 156, 1);
			white-space: nowrap;
			.iconpark-icon {
				font-size: 16px;
				margin-right: 6px;
				fill: rgba(169, 174, 184, 1);
			}
			&:hover {
				border-color: rgba(52, 145, 250, 1);
				color: rgba(52, 145, 250, 1);
				.iconpark-icon {
					fill: rgba(52, 145, 250, 1);
				}
			}
			&.active {
				border-color: rgba(52, 145, 250, 1);
				color: rgba(52, 145, 250, 1);
				.iconpark-icon {
					fill: rgba(52, 145, 250, 1);
				}
			}
		}
	}
}
.questionTypePopper {
	left: 252px !important;
	padding: 16px;
	.el-popover__title {
		color: rgba(29, 33, 41, 1);
		font-size: 14px;
		line-height: 22px;
		margin-bottom: 8px;
	}
	.el-input__inner {
		height: 32px;
		border: 1px solid rgba(229, 230, 235, 1);
		border-radius: 2px;
	}
	.el-radio {
		display: flex;
		height: 24px;
		align-items: center;
		.el-radio__inner {
			vertical-align: top;
		}
		.el-radio__label {
			color: rgba(134, 144, 156, 1);
		}
		& + .el-radio {
			margin-top: 8px;
		}
	}
	.el-checkbox {
		display: flex;
		height: 24px;
		align-items: center;
		.el-checkbox__inner {
			vertical-align: top;
		}
		.el-checkbox__label {
			color: rgba(134, 144, 156, 1);
		}
		& + .el-checkbox {
			margin-top: 8px;
		}
	}
	.el-select {
		display: block;
	}
}
</style>
